import { render, staticRenderFns } from "./CargoStatusAirHouse.vue?vue&type=template&id=dc27a6f0&"
import script from "./CargoStatusAirHouse.vue?vue&type=script&lang=js&"
export * from "./CargoStatusAirHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports